import { Dispatch, SetStateAction } from 'react';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { CheckMandateResponseBody } from '../../../../authorizations/src/domain/Authorization/entities/CheckMandateResponseDTO';
import { Account } from '../../../../account/src/domain/Account/entities';
import { TransactionDocument } from '../../domain/Transaction/entities/TransactionDocuments';
import {
  ConsolidatedTransaction,
  ConsolidatedTransactionDetails,
} from '../../domain/Transaction/entities/ConsolidatedTransaction';

export type TransactionDocumentsDataSetter = Dispatch<
  SetStateAction<{
    documents?: Nullable<TransactionDocument[]>;
    isLoading: boolean;
    error?: AxiosError<APIGatewayResponse<Nullable<TransactionDocument[]>>, any>;
  }>
>;

export interface ConsolidatedTransactionDetailsProviderProps {
  transactionList: Nullable<ConsolidatedTransaction[]>;
}

export type ConsolidatedTransactionListFilters = {
  fromAmount: string; // amount field
  toAmount: string;
  fromTrxDate: string;
  toTrxDate: string;
  pageSize: number;
  pageOffset: number;
  customerId: string;
  orderBeneficiaryAccount?: string;
  orderStatus?: number; // status field
  orderStatusDescription?: string; // description of status
  valueDateFrom?: string;
  valueDateTo?: string;
  account?: Nullable<Account>;
};

export type ConsolidatedTransactionDetailsProviderState = {
  checkAuthorizationData?: Nullable<CheckMandateResponseBody>;
  selectedConsolidatedTransaction?: Nullable<ConsolidatedTransaction & { timestamp?: string }>;
  consolidatedTransactionDetails?: Nullable<ConsolidatedTransactionDetails>;
  getTransactionDocuments: (orderId: number, dataSetter: TransactionDocumentsDataSetter) => void;
  getSingleFileDocumentData: (fileSn: number, referenceNumber: string) => void;
  onCheckAuthorizationMutation: () => void;
  onSelectConsolidatedTransaction: (transactionNo?: string) => void;
  resetSelectedConsolidatedTransaction: () => void;
  refetchConsolidatedTransactionDetails: Function;
  loadingState: {
    isLoadingConsolidatedTransactionDetails: boolean;
    isLoadingCheckAuthorization: boolean;
  };
  errorState: {
    consolidatedTransactionDetailsError?: AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails>, any>;
    checkAuthorizationError?: AxiosError<APIGatewayResponse<CheckMandateResponseBody>, any>;
  };
};

export enum ConsolidatedTransactionDetailsActionTypes {
  setSelectedConsolidatedTransaction = '@@/Transactions/setSelectedConsolidatedTransaction',
}
